module.exports = __webpack_public_path__ + "static/img/ui_title.7f78459.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/ui_title.png
// module id = EmfU
// module chunks = 0